<template>
  <cui-card
    variant="default"
    v-bind="$attrs"
    ref="cardRef"
    class="mb-2"
    :interactive="interactive"
    elevation="border"
  >
    <slot />
  </cui-card>
</template>

<script setup lang="ts">
import { ref } from "vue";

type Props = {
  interactive?: boolean;
};
const props = withDefaults(defineProps<Props>(), {
  interactive: false,
});

defineOptions({
  name: "dtpCard",
  inheritAttrs: false,
});

const cardRef = ref<any>(null);

// Expose the card ref for parent components that need it (like IstModal)
defineExpose({
  cardRef,
  $el: cardRef,
});
</script>
